import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";

const UtsavamTable = () => {
  const donations = useSelector((state) => state.donation?.donations || []);

  // Count utsavam
const counts = donations.reduce((acc, d) => {
  // ✅ utsavam irundha mattum include
  if (typeof d.utsavam === "string" && d.utsavam.trim() !== "") {
    const key = d.utsavam.trim();
    acc[key] = (acc[key] || 0) + 1;
  }
  return acc;
}, {});


  const rows = Object.keys(counts);
  const total = rows.reduce((sum, r) => sum + (counts[r] || 0), 0);

  return (
    <>
      <Box>
        <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 400 }}>
          Utsavam Summary
        </Typography>
      </Box>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "14px",
        }}
      >
        <thead>
          <tr style={{ background: "#f0f0f0" }}>
            <th style={{ border: "1px solid #ddd", padding: "6px" }}>
              Utsavam
            </th>
            <th style={{ border: "1px solid #ddd", padding: "6px" }}>
              Count
            </th>
          </tr>
        </thead>

        <tbody>
          {rows.map((r) => (
            <tr key={r}>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>{r}</td>
              <td style={{ border: "1px solid #ddd", padding: "6px" }}>
                {counts[r]}
              </td>
            </tr>
          ))}

          <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>Total</td>
            <td style={{ border: "1px solid #ddd", padding: "6px" }}>{total}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default UtsavamTable;